<template>
  <footer class="footer">
    <div class="content-width footer-inner">
      <div class="footer-top">
        <img
          src="@/assets/totally-money-logo.svg"
          alt="Totally Money"
          class="footer-logo"
        >
        <ul class="footer-links">
          <li>
            <a
              href="https://www.totallymoney.com/info/privacy-policy/"
              target="_blank"
            >Privacy</a>
          </li>
          <li>
            <a
              href="https://www.totallymoney.com/info/terms"
              target="_blank"
            >T&Cs</a>
          </li>
          <li>
            <a
              href="https://www.totallymoney.com/info/cookie-policy/"
              target="_blank"
            >Cookies</a>
          </li>
          <li>
            <a
              href="https://help.totallymoney.com/hc/en-gb"
              target="_blank"
            >Help & FAQs</a>
          </li>
        </ul>
      </div>
      <div class="footer-content">
        <p>
          TotallyMoney partners with Seopa Ltd (trading as Quotezone) to provide customers with a
          <a
            href="https://help.totallymoney.com/hc/en-gb/articles/360001008585-How-do-you-make-money"
            target="_blank"
          >free</a> car insurance comparison service. TotallyMoney acts as an insurance intermediary and receives commission for insurance policies taken out by customers from Seopa Ltd. Seopa Ltd in turn receive commission directly from the insurer. TotallyMoney does not provide insurance advice. You can see a list of the insurance providers which Seopa Ltd work with as part of this comparison service
          <a
            href="https://insurance.totallymoney.com/insurance-partners"
            target="_blank"
          >here</a>.
        </p>
        <p>TotallyMoney is owned and operated by TotallyMoney Limited which is registered in England and Wales (Company Registration Number 06205695). TotallyMoney Limited is an Appointed Representative of TM Connect Limited which is authorised and regulated by the Financial Conduct Authority in respect of insurance mediation activity (FCA FRN: 511936) and registered in England and Wales (Company Registration Number 06967012). You can check the Financial Services Register by visting the FCA website. Trading Address and Registered Office: Chapter House, 16 Brunswick Place, London N1 6DZ.</p>
        <p>Seopa Ltd is authorised and regulated by the Financial Conduct Authority in respect of insurance mediation activity  (FCA FRN: 313860). Seopa's registered office: Seopa Ltd, {{ constants.SEOPA_LTD_ADDRESS }}. Registered in Northern Ireland NI46322.</p>
      </div>
      <div class="footer-provided">
        <span>Car insurance comparison is provided by Seopa</span>
        <a
          href="https://www.seopa.com/co-brand-solutions"
          target="_blank"
        >
          <img
            src="@/assets/seopa-logo.png"
            alt="Seopa logo"
          >
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'partner-footer',
  inject: ['constants'],
};
</script>

<style lang="scss" scoped src="@/assets/scss/footer/core-footer-partners.scss"/>
<style lang="scss" scoped src="@/assets/scss/footer/footer-partners.scss"/>
